import * as React from "react";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { ButtonToolbar, Button, ControlLabel, FormControl, FormGroup } from "components/bootstrap";
import Popover from "components/common/Popover";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import useSaveViewFormControls from "views/hooks/useSaveViewFormControls";
import Alert from "components/bootstrap/Alert";
import styles from "./SavedSearchForm.css";
const stopEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};
const StyledPopoverDropdown = styled(Popover.Dropdown)``;
const SavedSearchForm = ({
  children = void 0,
  show,
  isCreateNew,
  saveSearch,
  saveAsSearch,
  toggleModal,
  value,
  viewId = null,
  selectedStreamGRN = null
}) => {
  const { dirty: formDirty } = useFormikContext();
  const { t } = useTranslation("search");
  const [title, setTitle] = useState(value);
  const [sharePayload, setSharePayload] = useState(null);
  const onChangeTitle = useCallback(
    (e) => setTitle(e.target.value),
    []
  );
  const trimmedTitle = (title != null ? title : "").trim();
  const disableSaveAs = trimmedTitle === "" || !isCreateNew && trimmedTitle === value;
  const createNewTitle = isCreateNew ? t("save_form.create_new") : t("save_form.save_as");
  const createNewButtonTitle = isCreateNew ? t("save_form.create_new_title") : t("save_form.save_as_title");
  const pluggableSaveViewControls = useSaveViewFormControls();
  const _saveSearch = useCallback(() => saveSearch(title, sharePayload), [saveSearch, title, sharePayload]);
  const _saveAsSearch = useCallback(() => saveAsSearch(title, sharePayload), [saveAsSearch, title, sharePayload]);
  return /* @__PURE__ */ React.createElement(Popover, { position: "left", width: 500, opened: show, withArrow: true, withinPortal: true }, /* @__PURE__ */ React.createElement(Popover.Target, null, children), /* @__PURE__ */ React.createElement(StyledPopoverDropdown, { title: t("save_form.popover_title"), id: "saved-search-popover" }, /* @__PURE__ */ React.createElement("form", { onSubmit: stopEvent }, formDirty && /* @__PURE__ */ React.createElement(Alert, { compact: true, noIcon: true, bsStyle: "warning" }, t("save_form.dirty_warning")), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, { htmlFor: "title" }, t("save_form.title_label")), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      value: title,
      id: "title",
      placeholder: t("save_form.title_placeholder"),
      onChange: onChangeTitle
    }
  )), pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(
    ({ component: Component, id }) => Component && /* @__PURE__ */ React.createElement(Component, { key: id, disabledViewCreation: disableSaveAs })
  ), !disableSaveAs && /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: t("save_form.share_description"),
      entityType: "search",
      entityTitle: "",
      entityId: isCreateNew ? null : viewId,
      dependenciesGRN: selectedStreamGRN,
      onSetEntityShare: (payload) => setSharePayload(payload)
    }
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, !isCreateNew && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      className: styles.button,
      type: "submit",
      bsSize: "sm",
      title: t("save_form.save_title"),
      onClick: _saveSearch
    },
    t("save_form.save")
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: disableSaveAs,
      bsStyle: "info",
      className: styles.button,
      type: "submit",
      bsSize: "sm",
      title: createNewButtonTitle,
      onClick: _saveAsSearch
    },
    createNewTitle
  ), /* @__PURE__ */ React.createElement(Button, { className: styles.button, onClick: toggleModal, bsSize: "sm" }, t("save_form.cancel"))))));
};
export default SavedSearchForm;
